import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import ReactPlayer from "react-player/vimeo";
import Color from "../../../assets/colors";

export const QuoteCard = styling(Box)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",

  backgroundColor: Color.white,
  border: `1.5px solid #AEAEAE`,
  borderRadius: "1rem",
  padding: "1.5rem",
  width: "100%",

  transition: "all 0.15s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      cursor: "pointer",
    },
  },

  "@media (max-width: 1280px)": {
    padding: "1rem",
  },
  "@media (max-width: 640px)": {
    gap: "1rem",
  },
});

export const TextContainer = styling("p")({
  display: "flex",
  flexDirection: "column",

  height: "100%",
  margin: 0,

  fontSize: "1rem",
  color: "rgba(0, 0, 0, 0.60)",

  "@media (max-width: 1280px)": {
    fontSize: "0.85rem",
  },
});

export const FontAwesomeIconStyled = styling(FontAwesomeIcon)({
  fontSize: "20px",
});

export const ReactPlayerStyled = styling(ReactPlayer)({
  minWidth: "100%",
  minHeight: "100%",
  objectFit: "cover",
  overflow: "hidden",
});
